import React from 'react'
import { Image, ImageSourcePropType, StyleProp, Text, TouchableOpacity, View, ViewStyle } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { BackButton } from '../BackButton/BackButton'
import { ViewObserverButton } from '../Observer/observer'
import { styles } from './style'
import { useDrawerStore } from '@/components/Drawer/Drawer'

export interface Header {
  title?: string
  navigate: () => void
  customStyle?: StyleProp<ViewStyle>
  observerPlayers?: string[]
  showEyeIcon?: boolean
  titleIcon?: ImageSourcePropType
}

export const DrawerHamburgerButton = () => {
  return (
    <TouchableOpacity
      onPress={async () => {
        useDrawerStore.getState().toggleDrawer()
      }}
    >
      <Image
        style={{ height: moderateScale(18), width: 24, marginLeft: 10 }}
        source={require('../../assets/Group.png')}
      />
    </TouchableOpacity>
  )
}

const NavigationHeader = (props: Header) => {
  return (
    <View style={[styles.container, props.customStyle]}>
      <View style={styles.leftView}>
        <View style={{ paddingLeft: 12 }}>
          <BackButton navigate={props.navigate} />
        </View>
      </View>
      <View style={styles.middleView}>
        <View style={styles.titleView}>
          {props.titleIcon ? (
            <Image source={props.titleIcon} style={styles.chatIcon} />
          ) : (
            <View
              style={{
                height: moderateScale(16)
              }}
            />
          )}
          <Text style={styles.title} numberOfLines={1} ellipsizeMode="tail">
            {props.title}
          </Text>
        </View>
      </View>
      <View style={styles.rightContainer}>
        <View style={styles.rightView}>
          {props.showEyeIcon ? (
            <ViewObserverButton disabled={!(props.observerPlayers && props.observerPlayers.length > 0)} />
          ) : (
            <View
              style={{
                height: moderateScale(16),
                width: 30
              }}
            />
          )}
          <DrawerHamburgerButton />
        </View>
      </View>
    </View>
  )
}

export default NavigationHeader
